import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from 'react-redux';
import {object, string} from 'prop-types';

import {formatPolygonArea, localizationMap} from '@explorer/util/format-area';
import {getAreaUnits} from '@explorer/selectors/measurements';

const AreaLabel = ({geometry, units}) => {
  if (!geometry) {
    return '';
  } else {
    const area = formatPolygonArea(geometry, units, '0,0.[000]');
    return localizationMap[units] ? (
      <Trans i18nKey={localizationMap[units]} values={{area}} />
    ) : null;
  }
};

AreaLabel.propTypes = {
  geometry: object,
  units: string.isRequired,
};

const mapStateToProps = state => ({
  units: getAreaUnits(state),
});

export default connect(mapStateToProps)(AreaLabel);
